import {
  Group,
  Box,
  ScrollArea,
  Text,
  useMantineTheme,
  ActionIcon,
  Paper,
  Button,
  Dialog,
} from "@mantine/core";
import { Trash, Settings, UserPlus } from "tabler-icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { useRolesQuery, useDeleteRoleMutation } from "services/api";
import { showNotification } from "@mantine/notifications";
import Table from "features/backstage/_shared/Table";

const List = () => {
  const theme = useMantineTheme();
  const { data: roles = [] } = useRolesQuery();

  const [deleteRole] = useDeleteRoleMutation();
  const [deleteRoleId, setDeleteRoleId] = useState<string>();

  const rows = roles.map((x) => (
    <tr key={x.roleNo}>
      <td>
        <Group spacing="sm">
          <Text size="sm" weight={500}>
            {x.roleNo}
          </Text>
        </Group>
      </td>
      <td>
        <Group spacing="sm">
          <Text size="sm" weight={500}>
            {x.roleName}
          </Text>
        </Group>
      </td>
      <td>
        <Group spacing={0} position="right">
          <ActionIcon color="gray" component={Link} to={`${x.roleNo}/edit`}>
            <Settings size={20} />
          </ActionIcon>
          <ActionIcon color="red" onClick={() => setDeleteRoleId(x.roleNo)}>
            <Trash size={20} />
          </ActionIcon>
        </Group>
      </td>
    </tr>
  ));

  return (
    <Box py={8} px={36}>
      <Group position="apart">
        <h2>權限角色設定</h2>
        <Button
          component={Link}
          to="new"
          leftIcon={<UserPlus />}
          variant="outline"
          color="cyan"
        >
          新增群組角色
        </Button>
      </Group>
      <Paper
        px={16}
        pt={8}
        pb={8}
        mt={16}
        radius={"lg"}
        shadow={theme.shadows.lg}
      >
        <ScrollArea>
          <Table>
            <thead>
              <tr>
                <th>No.</th>
                <th>角色名稱</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows
              ) : (
                <tr>
                  <td colSpan={3}>
                    <Text weight={500} align="center">
                      沒有找到相關資料
                    </Text>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ScrollArea>
      </Paper>

      <Dialog
        opened={deleteRoleId !== undefined}
        withCloseButton
        onClose={() => setDeleteRoleId(undefined)}
        size="lg"
        radius="md"
      >
        <Group align="center">
          <Text size="sm" weight={500}>
            確定刪除群組角色？
          </Text>
          <Button
            color="red"
            onClick={async () => {
              try {
                await deleteRole(deleteRoleId).unwrap();
              } catch (e) {
                if (e.status === 409) {
                  showNotification({
                    title: "刪除失敗",
                    message: "僅能刪除不包含任何人員的群組角色",
                    color: "red",
                  });
                }
              } finally {
                setDeleteRoleId(undefined);
              }
            }}
          >
            確認刪除
          </Button>
        </Group>
      </Dialog>
    </Box>
  );
};

export default List;
